import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getContactUsDetails = () => {
  const url = API_URLS.contactUsEndPoint;
  return axiosClient.get(url);
};
